import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {setCode, setStep, unsubscribeInit} from "@store/actions/unsubscribe";
import {removal} from "@store/actions/unsubscribe/removal";
import {confirmation} from "@store/actions/unsubscribe/confirmation";
import ConfirmationView from "@components/views/Unsubscribe/ConfirmationView/Main";

const ConfirmationViewContainer = (props) => {
    return (
        <ConfirmationView {...props}/>
    )
}

const mapStateToProps = (state) => (
    {
        unsubscribe: state.unsubscribe,
    }
);

const mapDispatchToProps = (dispatch) => (
    {
        actions: bindActionCreators(
            {
                unsubscribeInit,
                setStep,
                setCode,
                removal,
                confirmation,
            },
            dispatch,
        ),
    }
);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfirmationViewContainer);

